export default __webpack_public_path__ + "static/media/slider_2-xs@2x.ed493d71.webp";